import MapScreen from './MapScreen';
import { useNavigate } from 'react-router-dom';
import logoImage from "../../public/media/combined_images/logo.png";

export default function MapPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <header
        style={{
          height: 64,
          minHeight: 64,
          background: '#ffffff',
          borderBottom: '1px solid #e0e0e0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 24px',
          zIndex: 5000,
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 16,
          }}
        >
          <button
            onClick={() => navigate(-1)}
            aria-label="Go back"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 36,
              height: 36,
              borderRadius: 8,
              border: '1px solid #e0e0e0',
              background: '#fafafa',
              cursor: 'pointer',
              color: '#333',
              padding: 0,
            }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
          </button>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <img
              src={logoImage}
              alt="LIMS logo"
              style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                objectFit: 'contain',
              }}
            />

            <div>
              <div
                style={{
                  fontSize: 20,
                  fontWeight: 700,
                  color: '#2e7d32',
                  lineHeight: 1.1,
                }}
              >
                LIMS
              </div>

              <div
                style={{
                  fontSize: 11,
                  color: '#777',
                }}
              >
                Land Information Management System
              </div>
            </div>
          </div>
        </div>

      </header>

      <div
        style={{
          flex: 1,
          minHeight: 0,
        }}
      >
        <MapScreen />
      </div>
    </div>
  );
}